<section class="orders-history">

  <header class="orders-header">
    <h2>Historial de pedidos</h2>

    <label class="search-field">
      <span>Buscar pedido</span>
      <input
        type="search"
        placeholder="Código, cliente, producto o fecha"
        [value]="searchTerm()"
        (input)="onSearch($event)"
      />
    </label>
  </header>

  <label class="orders-history__filter">
    <span>Estado</span>
    <select #statusFilter [value]="activeFilter()" (change)="onFilterChange(statusFilter.value)">
      @for (filter of statusFilters; track filter.value) {
        <option [value]="filter.value">{{ filter.label }} ({{ countFor(filter.value) }})</option>
      }
    </select>
  </label>
  <!-- La tabla solo desaparece en la primera carga. Después se atenúa, para que
       escribir en el buscador no la haga parpadear en cada tecla. -->
  @if (isLoading() && orders().length === 0) {
    <p class="state-message">Cargando pedidos...</p>
  } @else {
    <div class="table-container" [class.is-refreshing]="isLoading()">
      <table class="orders-table" role="table" aria-label="Pedidos">
        <thead role="rowgroup">
          <tr>
            <th scope="col">Pedido</th>
            <th scope="col">Fecha</th>
            <th scope="col">Estado</th>
            <th scope="col">Tipo de envío</th>
            <th scope="col">Total</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>

        <tbody role="rowgroup">
          @for (order of orders(); track order.id) {
            <tr class="orders-history__row" role="row">
              <td class="orders-history__identity">
                <span class="order-items" [title]="order.title">
                  {{ order.title }}
                </span>
                <span class="order-number">{{ order.orderCode }}</span>
              </td>

              <td class="order-date">{{ order.date | date: dateFormat }}</td>

              <td class="orders-history__status">
                <div
                  class="status-cell"
                  [class.is-updating]="isUpdating(order.id)"
                  [class.is-final]="isFinalStatus(order.status, order.shippingType) || isPaymentPending(order)"
                  [attr.title]="statusCellHint(order)"
                >
                  <app-order-status-badge [status]="order.status" [shippingType]="order.shippingType" />

                  @if (isPaymentPending(order)) {
                    <span class="payment-pending-pill" [class.is-unconfirmed]="order.paymentStatus === 'unconfirmed'">{{ paymentPillLabel(order) }}</span>
                  }

                  <select
                    class="status-select"
                    [value]="order.status"
                    [disabled]="isUpdating(order.id) || isFinalStatus(order.status, order.shippingType) || isPaymentPending(order)"
                    [attr.aria-label]="'Cambiar estado del pedido ' + order.orderCode"
                    (change)="onStatusChange(order, $event)"
                  >
                    @for (status of selectableStatuses(order.status, order.shippingType); track status) {
                      <option [value]="status">{{ statusLabel(status, order.shippingType) }}</option>
                    }
                  </select>
                </div>
              </td>

              <td class="orders-history__shipping">{{ shippingLabel(order) }}</td>

              <td class="order-total">{{ order.total | clpCurrency }}</td>

              <td class="orders-history__actions">
                <div class="action-buttons">
                  <button
                    type="button"
                    class="btn-link"
                    [disabled]="isDetailLoading(order.id)"
                    (click)="openDetail(order)"
                  >
                    {{ isDetailLoading(order.id) ? 'Cargando...' : 'Ver detalle' }}
                  </button>

                  <button
                    type="button"
                    class="btn-copy"
                    [attr.aria-label]="'Copiar ID del pedido ' + order.orderCode"
                    [title]="'Copiar ID ' + order.orderCode"
                    (click)="copyOrderNumber(order)"
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="6" class="state-message">
                @if (searchTerm().trim()) {
                  No hay pedidos que coincidan con la búsqueda.
                } @else {
                  No hay pedidos registrados.
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      theme="admin"
      [currentPage]="currentPage()"
      [totalPages]="totalPages()"
      (pageChange)="onPageChange($event)"
    />
    @if (totalPages() > 1) {
      <nav class="orders-history__pagination" aria-label="Páginas de pedidos">
        <button type="button" [disabled]="isLoading() || currentPage() <= 1" (click)="onPageChange(currentPage() - 1)">Anterior</button>
        <span aria-live="polite">Página {{ currentPage() }} de {{ totalPages() }}</span>
        <button type="button" [disabled]="isLoading() || currentPage() >= totalPages()" (click)="onPageChange(currentPage() + 1)">Siguiente</button>
      </nav>
    }
  }

</section>
